import { NAME } from './constants';

export const FETCH_ACCESSORIES = `${NAME}/FETCH_ACCESSORIES`;
export const FETCH_ACCESSORIES_FAILURE = `${NAME}/FETCH_ACCESSORIES_FAILURE`;
export const FETCH_ACCESSORIES_SUCCESS = `${NAME}/FETCH_ACCESSORIES_SUCCESS`;

export const FETCH_DOCUMENTS = `${NAME}/FETCH_DOCUMENTS`;
export const FETCH_DOCUMENTS_FAILURE = `${NAME}/FETCH_DOCUMENTS_FAILURE`;
export const FETCH_DOCUMENTS_SUCCESS = `${NAME}/FETCH_DOCUMENTS_SUCCESS`;

export const FETCH_INCENTIVE_OFFER_COMPLEMENTS = `${NAME}/FETCH_INCENTIVE_OFFER_COMPLEMENTS`;
export const FETCH_INCENTIVE_OFFER_COMPLEMENTS_FAILURE = `${NAME}/FETCH_INCENTIVE_OFFER_COMPLEMENTS_FAILURE`;
export const FETCH_INCENTIVE_OFFER_COMPLEMENTS_SUCCESS = `${NAME}/FETCH_INCENTIVE_OFFER_COMPLEMENTS_SUCCESS`;

export const FETCH_INVERTERS = `${NAME}/FETCH_INVERTERS`;
export const FETCH_INVERTERS_FAILURE = `${NAME}/FETCH_INVERTERS_FAILURE`;
export const FETCH_INVERTERS_SUCCESS = `${NAME}/FETCH_INVERTERS_SUCCESS`;

export const FETCH_INVERTER_BRANDS = `${NAME}/FETCH_INVERTER_BRANDS`;
export const FETCH_INVERTER_BRANDS_FAILURE = `${NAME}/FETCH_INVERTER_BRANDS_FAILURE`;
export const FETCH_INVERTER_BRANDS_SUCCESS = `${NAME}/FETCH_INVERTER_BRANDS_SUCCESS`;

export const FETCH_PANELS = `${NAME}/FETCH_PANELS`;
export const FETCH_PANELS_FAILURE = `${NAME}/FETCH_PANELS_FAILURE`;
export const FETCH_PANELS_SUCCESS = `${NAME}/FETCH_PANELS_SUCCESS`;

export const FETCH_PANEL_BRANDS = `${NAME}/FETCH_PANEL_BRANDS`;
export const FETCH_PANEL_BRANDS_FAILURE = `${NAME}/FETCH_PANEL_BRANDS_FAILURE`;
export const FETCH_PANEL_BRANDS_SUCCESS = `${NAME}/FETCH_PANEL_BRANDS_SUCCESS`;

export const FETCH_PRODUCT = `${NAME}/FETCH_PRODUCT`;
export const FETCH_PRODUCT_FAILURE = `${NAME}/FETCH_PRODUCT_FAILURE`;
export const FETCH_PRODUCT_SUCCESS = `${NAME}/FETCH_PRODUCT_SUCCESS`;

export const FETCH_TEMPLATE_CATALOGS = `${NAME}/FETCH_TEMPLATE_CATALOGS`;
export const FETCH_TEMPLATE_CATALOGS_FAILURE = `${NAME}/FETCH_TEMPLATE_CATALOGS_FAILURE`;
export const FETCH_TEMPLATE_CATALOGS_SUCCESS = `${NAME}/FETCH_TEMPLATE_CATALOGS_SUCCESS`;

export const INITIALIZE_AUTH_EMAILS_FORM = `${NAME}/INITIALIZE_AUTH_EMAILS_FORM`;
export const INITIALIZE_FORM = `${NAME}/INITIALIZE_FORM`;

export const OPEN_MODAL_PRODUCT = `${NAME}/OPEN_MODAL_PRODUCT`;

export const RESET_AUTH_EMAILS_FORM = `${NAME}/RESET_AUTH_EMAILS_FORM`;

export const RESET_FORM = `${NAME}/RESET_FORM`;

export const SET_IS_OPEN_EMAILS_MODAL = `${NAME}/SET_IS_OPEN_EMAILS_MODAL`;

export const SAVE_PRODUCT = `${NAME}/SAVE_PRODUCT`;
export const SAVE_PRODUCT_FAILURE = `${NAME}/SAVE_PRODUCT_FAILURE`;
export const SAVE_PRODUCT_SUCCESS = `${NAME}/SAVE_PRODUCT_SUCCESS`;
